function getSpacePreview(requestUrl, finished) {

    try {

        ///console.log("Requesting file: " + requestUrl);
        fetch(requestUrl).
            then(response => {
                if (response.ok) {
                    response.blob().then(
                        (info) => {
                            const blobUrl = URL.createObjectURL(info);
                            ///console.log("Dowloaded image : " + requestUrl + " and created blob at location: " + blobUrl);
                            finished(blobUrl);
                        })
                }
                else {
                    ///console.log("Requesting failed");
                    finished("null");
                    //throw new Error('Network response was not ok: ' + response.statusText);
                }
            }
            );
    } catch (error) {

        finished("null");
    }

};

export default getSpacePreview;
